import { PASTEL_TONES } from '../../../../shared/pastelTones.js'
import { fillIcon } from '../../../../shared/announcementIcons.js'

// Draws one of the apps' own pictures on the website.
//
// The whole point: the art is NOT redrawn for the web. `shared/howItWorksArt.js`,
// `heroMomentArt.js`, `workerSectionArt.js` and `onboardingSectionArt.js` hold the
// same SVG strings the worker app and the Hub render with react-native-svg, with
// {{slot}} placeholders that fillIcon() fills from shared/pastelTones.js. So a
// visitor sees on the website exactly the picture they will meet in the app a week
// later, and it can never drift, because there is one copy.
//
// The site is light only (spec §2.6), so the tones are always the light set.
//
// `alt` is the exception, not the rule. These are decorative: the section’s words
// carry the meaning, and a screen reader announcing "a yellow clock and a pink
// moon" helps nobody. Pass `alt` only where the picture IS the content.
export default function Art({ xml, className = '', alt = '', style }) {
  if (!xml) return null
  return (
    <span
      className={`inline-block ${className}`}
      style={style}
      role={alt ? 'img' : 'presentation'}
      aria-label={alt || undefined}
      aria-hidden={alt ? undefined : 'true'}
      dangerouslySetInnerHTML={{ __html: fillIcon(xml, PASTEL_TONES.light) }}
    />
  )
}
